<app-mat-spinner-overlay *ngIf="this.loading" [overlay]="true">
</app-mat-spinner-overlay>

<div *ngIf="usuario && usuario.sucesso" [ngClass]="usuario.retorno.aparencia" class="container-fluid">
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li>
      <span id="lblSubMenu">Aprovar Edição de abastecimento da Frota</span>
    </li>
  </ul>
  <div class="panel panel-info">
    <div class="panel-heading">
      <h3 class="panel-title">Dados do abastecimento editado:<b> {{abastecimento?.codAbastecimento}}</b></h3>
    </div>
    <div class="panel-body">
      <div class="row">

        <div class="col-md-2 form-group">
          <label class='center-block'>
            Cód. do Abastecimento
          </label>
          <input
            [ngModel]="abastecimento?.codAbastecimento"
            class="form-control"
            disabled
            name="codigoFrota"
            type="text">
        </div>

        <div class="col-md-2 form-group">
          <label class='center-block'>
            Placa do veículo
          </label>
          <input [ngModel]="abastecimento?.dscPlaca" class="form-control" disabled
                 type="text">
        </div>

        <div class="col-md-5 form-group">
          <label class='center-block'>
            Nome do posto
          </label>
          <input [ngModel]="abastecimento?.nomFantasiaPosto" class="form-control" disabled
                 type="text">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Código do posto
          </label>
          <input [ngModel]="abastecimento?.codPosto" class="form-control" disabled
                 type="text">
        </div>
      </div>

      <div class="row">

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Abastecimento
          </label>
          <input [ngModel]="abastecimento?.datAbastecimento" class="form-control"
                 disabled
                 type="text">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Debito
          </label>
          <input [ngModel]="abastecimento?.datDebito" class="form-control"
                 disabled
                 type="text">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Data/Hora do Crédito
          </label>
          <input [ngModel]="abastecimento?.datCredito" class="form-control"
                 disabled
                 type="text">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Tipo do Produto
          </label>
          <input [ngModel]="abastecimento?.dscTipoProduto"
                 class="form-control"
                 disabled
                 type="text">
        </div>
      </div>


      <div class="row">
        <div class="col-md-3 form-group">
          <label class="control-label">
            Combustível Abastecido
          </label>
          <div class="input-group">
            <select class="form-control"

                    disabled
            >
              <option *ngFor="let comb of listaCombustiveis"
                      [selected]="comb.descricaoCombustivel.trim().toUpperCase() === abastecimento?.indCombustivel?.trim()?.toUpperCase()"
                      [value]="comb.descricaoCombustivel">{{comb.combustivel | titlecase}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 form-group">
          <label class='center-block'>
            Km do veiculo
          </label>
          <input [ngModel]="abastecimento?.numKm" class="form-control" disabled type="text">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Volume abastecido (l)
          </label>
          <input
            [ngModel]="abastecimento?.qtdVolume"
            class="form-control" disabled step="0.1" type="number">
        </div>

        <div class="col-md-3 form-group">
          <label class='center-block'>
            Preço / Litro
          </label>
          <input
            [ngModel]="abastecimento?.vlrUnitario | currency: 'R$'" class="form-control"
                 disabled type="text">
        </div>



      </div>

      <div class="row">
        <div class="col-md-4 form-group">
          <label class='center-block'>
            Número do Chamado
          </label>
          <input
            [ngModel]="abastecimento?.numChamado"
            disabled
            type="text" class="form-control preco-total">
          </div>


        <div class="offset-md-4 col-md-4 form-group">
          <label class='center-block'>
            Preço Total
          </label>
          <input [ngModel]="abastecimento?.vlrTotal | currency: 'R$'" class="form-control preco-total" disabled
                 step="0.1"
                 type="text"
          >
        </div>
      </div>


      <div class="row">
        <div class="offset-md-8 col-md-4 botoes pull-right ">

          <button (click)="cancelar()"
                  class="btn btn-secondary btn-submit btn-filtrar"
                  type="submit">
            <i class="fa fa-undo"></i>Cancelar
          </button>

          <button (click)="salvar()"
                  class="btn btn-primary btn-submit btn-filtrar"
                  type="submit">
            <i class="fa fa-check"></i>Aprovar
          </button>


        </div>
      </div>

    </div>
  </div>


</div>

